import { useMemo, useState } from 'react';

// Assign stable colors before filtering the visible series list.
export const useSeriesVisibility = <T extends { id: string }>(series: T[]) => {
  const [hiddenIds, setHiddenIds] = useState<string[]>([]);

  const toggle = (id: string) =>
    setHiddenIds((current) => (current.includes(id) ? current.filter((hiddenId) => hiddenId !== id) : [...current, id]));

  const visibleSeries = useMemo(() => series.filter((item) => !hiddenIds.includes(item.id)), [series, hiddenIds]);

  return { hiddenIds, toggle, visibleSeries };
};
